import { useTranslation, Trans } from "react-i18next";

interface DeleteAccountCardProps {
  onDelete: () => void;
  loading?: boolean;
}

import { Trash2, AlertTriangle } from "lucide-react";

export default function DeleteAccountCard({ onDelete, loading }: DeleteAccountCardProps) {
  const { t } = useTranslation();

  return (
    <div className="glass-effect glass-border border-red-200/50 dark:border-red-500/20 rounded-3xl p-8 shadow-theme-sm bg-red-50/30 dark:bg-red-500/5 relative overflow-hidden">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-2xl bg-red-100 dark:bg-red-500/20 text-red-600 dark:text-red-400 flex items-center justify-center shadow-theme-xs flex-shrink-0">
            <AlertTriangle className="w-6 h-6" />
          </div>
          <div className="space-y-1">
            <h4 className="text-xl font-bold text-red-700 dark:text-red-400">
              {t("profile.deleteAccount")}
            </h4>
            <p className="text-sm text-red-600/80 dark:text-red-400/60 max-w-lg leading-relaxed">
              <Trans
                i18nKey="profile.deleteWarning"
                components={{ 1: <strong className="font-bold text-red-700 dark:text-red-300" /> }}
              />
            </p>
          </div>
        </div>

        <button
          onClick={onDelete}
          disabled={loading}
          className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-xl bg-red-600 text-white hover:bg-red-700 active:bg-red-800 transition-all font-bold text-sm shadow-lg shadow-red-500/20 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
        >
          <Trash2 className="w-4 h-4" />
          {loading ? t("common.deleting") : t("profile.deleteAccount")}
        </button>
      </div>

      {/* Decorative gradient */}
      <div className="absolute top-0 right-0 -tr-x-1/4 -tr-y-1/4 w-32 h-32 bg-red-500/5 rounded-full blur-3xl pointer-events-none" />
    </div>
  );
}
